<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Jonathan Maberry</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width"><i>“If you’re looking for tense excitement and walking dead meat, welcome to the world of one of the masters of the zombie tale. Maberry could give a haint the willies.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Joe R. Lansdale is a <i>New York Times</i> bestseller, ten-time Bram Stoker Award winner, Edgar Award winner, World Horror Convention Grand Master Award, and Raymond Chandler Lifetime Achievement Award</p>
</div>
</div>
<p class="subsq"><i>“A horror triumph … just razor-sharp stuff. Maberry grabs you by the heart—then smashes you with rabbit punch prose. Each story explodes off the page.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>New York Times</i> bestselling author Max Brallier</p>
</div>
</div>
<p class="subsq"><i>“Never did we who performed in George Romero’s 1968 </i>Night of the Living Dead<i> ever imagine our film would be instrumental in giving birth to a zombie apocalypse that for over 50 years, has flamed a ghoulish fascination with the walking dead. And now, to my mind, there is no one better than author Jonathan Maberry to keep that apocalypse alive and thriving. His short story collection </i>Empty Graves: Tales of the Living Dead<i> is truly one of the most well-written, fascinating collections about our beloved zombies that I have ever read. Yes, I shuddered at the vicious relentlessness of the ghouls, but I also shed tears and laughter at the depth of humanity Jonathan brought to each story. Stephen King, eat your heart out. Jonathan Maberry stands tall beside you as a master of horror.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Judith O’Dea (Barbra in the original <i>Night of the Living Dead</i>)</p>
</div>
</div>
<p class="subsq"><i>“If Ernest Hemingway wrote about the undead, you would have something approaching these brilliant, surgical excursions into zombie-lit by Jonathan Maberry in his new collection </i>Empty Graves<i>. Action packed, character-driven, disturbing as hell, and excruciatingly humane, these stories stick with you, and will live alongside the best of the genre. Highest recommendation!”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Jay Bonansinga, <i>New York Times</i> bestselling author of <i>The Walking Dead: Return to Woodbury.</i></p>
</div>
</div>
<p class="subsq"><i>“A big, meaty feast of classic zombie thrills.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>New York Times</i> bestseller Isaac Marion, author of <i>Warm Bodies</i></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-jonathan-maberry.vue?c400e3f2